<div *ngIf="enrichedBadges?.length" [ngClass]="{'horizontalOnly' : horizontalOnly, 'directHire' : isDirectHire, 'badge-container' : !isDirectHire}">
  <div class="card">
    <div>
      <div class="inner">
        <div *ngFor="let badge of enrichedBadges" class="badges staffer-badge-desktop" [title]="badge.description">
          <div class="badge">
            <img *ngIf="getBadgeImage(badge.badgeKey)" [src]="getBadgeImage(badge.badgeKey)" [alt]="badge.label" class="badge-img" />
            <i *ngIf="!getBadgeImage(badge.badgeKey)" class="fa fa-certificate fa-icon" aria-hidden="true"></i>
          </div>
          <h4 class="badge-text">
            {{ badge.label }}
          </h4>
        </div>
        <div style="width: 10px"></div>
      </div>
    </div>
  </div>
</div>
